export default __webpack_public_path__ + "static/media/nepal_female_clients_reached.b3456a1b.jpg";